import { useContext, useEffect } from "react";
import { audioContext } from "../contexts/AudioContext";
import { LOGS } from "../utils/logging";
import { RadioName, RadioState, SceneAudioConfig } from "../../config/audio/types";

export function useSyncAudioData(next: SceneAudioConfig) {
	const { setCurrentPlaylists, hasUserGestured, setRadioState } = useContext(audioContext);

	useEffect(() => {
		if (!hasUserGestured) return;
		setCurrentPlaylists(next.playlists);
	}, [next.playlists, hasUserGestured, setCurrentPlaylists]);

	useEffect(() => {
		const sceneRadios = next.radios;
		setRadioState((prev) => {
			const updatedRadios = sceneRadios.reduce(
				(acc, { name, gain }) => {
					acc[name] = {
						...prev[name],
						gain: gain,
					};
					return acc;
				},
				{} as Record<RadioName, RadioState>,
			);

			LOGS.AUDIO && console.log("Updating the radio state: ", updatedRadios);

			return {
				...prev,
				...updatedRadios,
			};
		});
	}, [next.radios]);
}
